import type { ComposantEcran } from '../../app/ecrans.js';
import { EcranModeGuide } from './EcranModeGuide.js';

/** Couloir G, point 1 : poste de pilotage du mode guidé, lu par `import.meta.glob('../features/*\/index.{ts,tsx}')` de la coquille. */
export const ecrans: Readonly<Record<string, ComposantEcran>> = { D18: EcranModeGuide };
